<template>
  <div>
    <div class="flex items-center justify-between mb-6">
      <h1 class="text-xl font-bold">{{ categoryName }}</h1>
    </div>

    <div v-if="loading" class="flex justify-center py-12">
      <app-loading />
    </div>

    <div v-else-if="error" class="bg-background-light rounded-xl p-6 text-center">
      <p class="text-red-500">{{ error }}</p>
    </div>

    <div v-else-if="subcategories.length === 0" class="bg-background-light rounded-xl p-6 text-center">
      <p class="text-text-secondary">No subcategories available in this category</p>
    </div>

    <div v-else class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
      <subcategory-card
          v-for="subcategory in subcategories"
          :key="subcategory.id"
          :subcategory="subcategory"
          :category="category"
      />
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import SubcategoryCard from '../components/product/SubcategoryCard.vue';
import { useDataStore } from '@/stores/dataStore.js'

export default {
  name: 'CategoryListing',
  components: {
    SubcategoryCard
  },
  props: {
    categorySlug: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const route = useRoute();
    const router = useRouter();
    const loading = ref(true);
    const subcategories = ref([]);
    const category = ref(null);
    const dataStore = useDataStore();
    const error = ref(null);

    // Computed property for category name
    const categoryName = computed(() => {
      return category.value ? category.value.libelle : 'Category';
    });

    // Function to load data from API
    const loadData = async () => {
      try {
        loading.value = true;
        error.value = null;

        // Ensure data store is ready
        if (!dataStore.isDataReady) {
          await dataStore.fetchData();
        }


        // Get category by slug
        category.value = dataStore.getCategoryBySlug(props.categorySlug);


        if (!category.value) {
          error.value = 'Category not found';
          await router.push('/404');
          return;
        }

        // Get subcategories for this category
        subcategories.value = dataStore.getSubcategoriesByCategoryId(category.value.id);
      } catch (err) {
        console.error('Failed to load category data:', err);
        error.value = 'Failed to load category data.';
      } finally {
        loading.value = false;
      }
    };

    // Load data when component mounts
    onMounted(() => {
      loadData();
    });

    // Watch for slug changes from route or props
    watch(() => props.categorySlug, () => {
      loadData();
    });

    return {
      loading,
      error,
      subcategories,
      category,
      categoryName // ✅ Add this to return
    };
  }
}
</script>
